import React, { useState } from "react";
import Style from './LeftNavigation.module.css';
import Hourglass from '../../../assets/svg/Hourglass.svg';
import Shield from '../../../assets/svg/Shield.svg';
import Person from '../../../assets/svg/Person.svg';
import Avatar from '../../../components/controls/avatar/Avatar';
import Tab from './tabs/Tab';
import { useEffect } from "react";

const LeftNavBar = (props) => {
    const { user, currentTab } = props;
    const [activeTab, setActiveTab] = useState(1);
    const [userInfo, setUserInfo] = useState(JSON.parse(user));

    const handleActiveTab = (e) => {
        setActiveTab(e);
        currentTab(e)
    }
    const tabs = [
        {
            id: 1,
            label: 'Your info',
            logo: Person,
            cssClass: Style.infoWrapper,
        },
        {
            id: 2,
            label: 'Security',
            logo: Shield,
            cssClass: Style.securityWrapper,
        },
        {
            id: 3,
            label: 'Working hours',
            logo: Hourglass,
            cssClass: Style.hoursWrapper,
        }
    ];

    useEffect(() => {
        setUserInfo(JSON.parse(user));
    }, [user])
    return (
        <div className={Style.mainWrapper}>
            <div className={Style.wrapper}>
                <div className={Style.logoWrapper}>
                    {userInfo.profilePictureUrl !== null ?
                        <img src={userInfo.profilePictureUrl} alt="" />
                        :
                        <Avatar name={userInfo.fullName} cssClass={Style.avatar} />
                    }
                    <div>
                        <p className={`${Style.userName} font-family-imp`}>{userInfo.fullName}</p>
                        <p className={`${Style.userEmail} font-family-imp`}>{userInfo.email}</p>
                    </div>
                </div>
                {tabs.map((item, index) => <Tab item={item} index={item.id} key={index} setActiveTab={handleActiveTab} isActive={activeTab === item.id} />)}
            </div>
        </div>
    );
}

export default LeftNavBar;